// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__15UKA","title":"AfterFrontImage_title__3fTJh"};